import React from 'react';
import FormInput from './FormInput';

const VoxChatForm = ({ vinculo, setVinculo }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name.startsWith('config.')) {
      const configKey = name.split('.')[1];
      setVinculo(prev => ({
        ...prev,
        config: {
          ...prev.config,
          [configKey]: value
        }
      }));
    } else {
      setVinculo(prev => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <FormInput
        label="Nome da Organização"
        name="nome_organizacao"
        value={vinculo.nome_organizacao}
        onChange={handleChange}
        required
        placeholder="Ex: Empresa XYZ"
      />

      <FormInput
        label="E-mail do Cliente"
        type="email"
        name="email_cliente"
        value={vinculo.email_cliente}
        onChange={handleChange}
        required
        placeholder="cliente@empresa.com"
      />

      <FormInput
        label="Senha"
        type="password"
        name="senha"
        value={vinculo.senha}
        onChange={handleChange}
        required
        placeholder="••••••••"
      />

      <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-2">
        <h4 className="text-base font-semibold text-gray-900 dark:text-white mb-3">
          Configurações do Vox Chat
        </h4>
        
        <div className="grid grid-cols-2 gap-3">
          <FormInput
            label="Máx. Usuários"
            type="number"
            name="config.max_usuarios"
            value={vinculo.config.max_usuarios}
            onChange={handleChange}
            min="1"
          />

          <FormInput
            label="Máx. Grupos"
            type="number"
            name="config.max_grupos"
            value={vinculo.config.max_grupos}
            onChange={handleChange}
            min="1"
          />

          <div className="col-span-2">
            <FormInput
              label="Storage (MB)"
              type="number"
              name="config.storage_mb"
              value={vinculo.config.storage_mb}
              onChange={handleChange}
              min="100"
              step="100"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoxChatForm;

